import { AutogenLayoutLocationContactQuickInfo } from "./autogen/AutogenLayoutLocationContactQuickInfo";

export class LocationContactQuickInfo extends AutogenLayoutLocationContactQuickInfo {
}
